import React from "react";
// import "./dashboard.css";

// function Dashboard() {

//   return (

//     <div className="dashboard">

//       <div className="dashboard-content">

//         <h1>
//           Welcome Admin 👋
//         </h1>

//         <div className="cards">

//           {/* Trainers */}
//           <div className="dash-card">
//             <h2>
//               Trainers
//             </h2>

//             <p>
//               Manage Registered Trainers
//             </p>
//           </div>


//           {/* Partners */}
//           <div className="dash-card">
//             <h2>
//               Partners
//             </h2>

//             <p>
//               Manage Corporate Partners
//             </p>
//           </div>


//           {/* Employees */}
//           <div className="dash-card">
//             <h2>
//               Employees
//             </h2>

//             <p>
//               Manage Registered Employees
//             </p>
//           </div>

//         </div>

//       </div>

//     </div>

//   );
// }



function Dashboard() {
  return (
    <div className="dashboard">
      <h1>Welcome Admin 👋</h1>
    </div>
  );
}
export default Dashboard;